import { render, staticRenderFns } from "./plan.vue?vue&type=template&id=461be58a&scoped=true&"
import script from "./plan.vue?vue&type=script&lang=js&"
export * from "./plan.vue?vue&type=script&lang=js&"
import style0 from "./plan.vue?vue&type=style&index=0&id=461be58a&prod&lang=scss&scoped=true&"
import style1 from "./plan.vue?vue&type=style&index=1&id=461be58a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461be58a",
  null
  
)

export default component.exports